import React from 'react';
import type { GetServerSideProps } from 'next';

import { EXPLAINED_TERMS_SLUG_BLOCKLIST } from '../utils/is-in-explained-blocklist';
import { ExplainedTerm, Offer, Placeholder } from '../../src/client/types/__codegen__/sanity/graphql';
import ConsiderationLandingPageTemplate, {
  getTemplateServerSideProps,
} from '../../components/page-templates/consideration-landing-page-template';
import type { TableOfContentsItem } from '../../src/client/types/sanityInternal';

const slug = EXPLAINED_TERMS_SLUG_BLOCKLIST.HEALTH_INSURANCE_LANDING_PAGE;

export type HealthInsurancePageProps = {
  activeOffers: Offer[];
  placeholders: Placeholder[];
  serverSideData: {
    contact: {
      items: TableOfContentsItem[];
      name: string;
    };
    explainedTerm: ExplainedTerm;
  };
};

const HealthInsurancePage = ({
  activeOffers: serverSideOffers,
  placeholders: serverSidePlaceholders,
  serverSideData,
}: HealthInsurancePageProps) => (
  <ConsiderationLandingPageTemplate
    activeOffers={serverSideOffers}
    placeholders={serverSidePlaceholders}
    serverSideData={serverSideData}
    slug={slug}
  />
);

export const getServerSideProps: GetServerSideProps = getTemplateServerSideProps({ slug });

export default HealthInsurancePage;
